// extracted by mini-css-extract-plugin
export default {"left":"alRdB","external":"blRdB","center":"clRdB","right":"dlRdB"};